var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9905 11.4287H16.8491C14.3634 11.4287 12.3483 13.4439 12.3483 15.9292V22.0709C12.3483 24.5566 14.3631 26.5714 16.8491 26.5714H22.9905C25.4761 26.5714 27.4913 24.5566 27.4913 22.0709V15.9292C27.4913 13.4439 25.4761 11.4287 22.9905 11.4287ZM26.0139 22.0036C26.0139 23.7108 24.63 25.0947 22.9228 25.0947H16.9171C15.2099 25.0947 13.826 23.7108 13.826 22.0036V15.9972C13.826 14.29 15.2099 12.9061 16.9171 12.9061H22.9228C24.63 12.9061 26.0139 14.29 26.0139 15.9972V22.0036Z",
    fill: "url(#paint0_linear_9_2730)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0228 15.2037C17.9881 15.2037 16.3329 16.859 16.3329 18.8933C16.3329 20.928 17.9885 22.5832 20.0228 22.5832C22.0572 22.5832 23.7124 20.928 23.7124 18.8933C23.7127 16.8593 22.0572 15.2037 20.0228 15.2037ZM20.0228 21.2572C18.7195 21.2572 17.6589 20.197 17.6589 18.8933C17.6589 17.59 18.7195 16.5297 20.0228 16.5297C21.3258 16.5297 22.3864 17.59 22.3864 18.8933C22.3864 20.197 21.3261 21.2572 20.0228 21.2572Z",
    fill: "url(#paint1_linear_9_2730)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9279 14.0771C23.4428 14.0771 23.0494 14.4706 23.0494 14.9557C23.0494 15.4408 23.4428 15.8342 23.9279 15.8342C24.4131 15.8342 24.8065 15.4408 24.8065 14.9557C24.8065 14.4706 24.4131 14.0771 23.9279 14.0771Z",
    fill: "url(#paint2_linear_9_2730)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9196 0C9.42633 0 0.919617 8.50672 0.919617 19C0.919617 29.4936 9.42633 38 19.9196 38C30.4132 38 38.9196 29.4933 38.9196 19C38.92 8.50672 30.4132 0 19.9196 0ZM19.9196 35.3958C10.8793 35.3958 3.52419 28.0407 3.52419 19.0003C3.52419 9.96002 10.8793 2.60492 19.9196 2.60492C28.9603 2.60492 36.315 9.96002 36.315 19.0003C36.3154 28.0407 28.9603 35.3958 19.9196 35.3958Z",
    fill: "url(#paint3_linear_9_2730)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_2730",
    x1: 6.62009,
    y1: 5.46724,
    x2: 33.1263,
    y2: 32.4384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_2730",
    x1: 6.72575,
    y1: 5.36341,
    x2: 33.2319,
    y2: 32.3345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_2730",
    x1: 10.681,
    y1: 1.47626,
    x2: 37.1871,
    y2: 28.4474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9_2730",
    x1: 6.602,
    y1: 5.44875,
    x2: 33.1081,
    y2: 32.4199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramicon);
export default __webpack_public_path__ + "static/media/instagramicon.54fbd5f6f829ef8d409f1df825ffb08f.svg";
export { ForwardRef as ReactComponent };